import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const fetchStream = (streamId) => {
  const { url } = ApiRoutes.StreamsApiController.get(streamId);
  return fetch("GET", qualifyUrl(url));
};
const useStream = (streamId, { enabled, refetchInterval } = {
  enabled: true,
  refetchInterval: false
}) => {
  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: ["stream", streamId],
    queryFn: () => defaultOnError(
      fetchStream(streamId),
      i18n.t("stream_hooks.load_stream_failed", { ns: "streams" }),
      i18n.t("stream_hooks.load_stream_failed_title", { ns: "streams" })
    ),
    placeholderData: keepPreviousData,
    enabled,
    refetchInterval
  });
  return {
    data,
    refetch,
    isFetching,
    isError
  };
};
export default useStream;
